'use strict';
import Promise from 'bluebird';
import $ from 'jquery';
import getToken from './token';

const BASE_URL = '/fi/api/v1/users/';

export const sendBenefitSms = (userId, benefitId) => {
	return getToken().then(token => {
		const url = `${BASE_URL}${userId}/benefits/${benefitId}/sms`;
		return Promise
			.resolve($.post(url, {token}))
			.then(res => res && res.result === true ? res : Promise.reject())
	});
}

export const getUser = userId =>
	Promise.resolve($.getJSON(`${BASE_URL}${userId}`));
